import React from 'react';
// import { connect } from 'react-redux';
// import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
// import { Row,Col,Table } from 'antd';
// import { fetchPersonalCenter } from '../../actions/employee-actions';
@LayoutWrapper
export default class PersonalCenter extends React.Component {
	componentWillMount() {
    sessionStorage.setItem("rosterReadOnly", "yes")
    sessionStorage.setItem("hideBackButton", "yes")
    this.props.history.push("/employee/detail-en/" + this.props.webCurrentUser.employeeUserInfo.Employee_id+"?disabled=true")
	}
	render() {
		return ""
	}
	// columnsCompany = [{title: "部门",
	// 				key: "department_name",
	// 				dataIndex: "department_name",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "兼任职位",
	// 				key: "position_name",
	// 				dataIndex: "position_name",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "开始日期",
	// 				key: "start_date",
	// 				dataIndex: "start_date",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "结束日期",
	// 				key: "end_date",
	// 				dataIndex: "end_date",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "备注",
	// 				key: "remarks",
	// 				dataIndex: "remarks",
	// 				className: 'table-global-head'
	// 			}]
	// columnsEducations = [{title: "学校",
	// 				key: "school_name",
	// 				dataIndex: "school_name",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "专业",
	// 				key: "major",
	// 				dataIndex: "major",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "学历",
	// 				key: "education_experience",
	// 				dataIndex: "education_experience",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "是否取得学位",
	// 				key: "get_degree",
	// 				dataIndex: "get_degree",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "开始日期",
	// 				key: "entry_date_edu",
	// 				dataIndex: "entry_date_edu",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "结束日期",
	// 				key: "completion_date",
	// 				dataIndex: "completion_date",
	// 				className: 'table-global-head'
	// 			}]
	// columnsExperiences = [{title: "公司名称",
	// 				key: "company_name",
	// 				dataIndex: "company_name",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "担任职位",
	// 				key: "position",
	// 				dataIndex: "position",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "入职日期",
	// 				key: "entry_date",
	// 				dataIndex: "entry_date",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "离职日期",
	// 				key: "leave_date",
	// 				dataIndex: "leave_date",
	// 				className: 'table-global-head'
	// 			},{
	// 				title: "职位描述",
	// 				key: "position_description",
	// 				dataIndex: "position_description",
	// 				className: 'table-global-head'
	// 			}]
	// render() {
	// 	const { personalCenterDetail,personalEducations,personalExperiences,personalParttimes } = this.props.employee;
	// 	console.log(personalCenterDetail);
	// 	return (
	// 		<div className="app-module-item">
	// 			<div className="remindingImportant">个人中心</div>
	// 			{personalCenterDetail&&
	// 				<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">显示名：</Col>
	// 						<Col span={6}>{personalCenterDetail.real_name}</Col>
	// 						<Col span={2} className="textRight">工号：</Col>
	// 						<Col span={6}>{personalCenterDetail.job_number}</Col>
	// 						<Col span={2} className="textRight">性别：</Col>
	// 						<Col span={6}>{personalCenterDetail.gender}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">姓名：</Col>
	// 						<Col span={6}>{personalCenterDetail.family_name} {personalCenterDetail.given_name}</Col>
	// 						<Col span={2} className="textRight">部门：</Col>
	// 						<Col span={6}>{personalCenterDetail.department_name}</Col>
	// 						<Col span={2} className="textRight">职位：</Col>
	// 						<Col span={6}>{personalCenterDetail.position_name}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">职级：</Col>
	// 						<Col span={6}>{personalCenterDetail.business_name}</Col>
	// 						<Col span={2} className="textRight">证件类型：</Col>
	// 						<Col span={6}>{personalCenterDetail.id_name}</Col>
	// 						<Col span={2} className="textRight">证件号：</Col>
	// 						<Col span={6}>{personalCenterDetail.id_number}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">手机号码：</Col>
	// 						<Col span={6}>{personalCenterDetail.cell_phone}</Col>
	// 						<Col span={2} className="textRight">合同类型：</Col>
	// 						<Col span={6}>{personalCenterDetail.contract_type_name}</Col>
	// 						<Col span={2} className="textRight">员工类型：</Col>
	// 						<Col span={6}>{personalCenterDetail.employee_type_name}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">工龄：</Col>
	// 						<Col span={6}>{personalCenterDetail.service_length_history}</Col>
	// 						<Col span={2} className="textRight">工作地点：</Col>
	// 						<Col span={6}>{personalCenterDetail.work_place}</Col>
	// 						<Col span={2} className="textRight">联系地址：</Col>
	// 						<Col span={6}>{personalCenterDetail.contact_address}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">国籍：</Col>
	// 						<Col span={6}>{personalCenterDetail.nationality_name}</Col>
	// 						<Col span={2} className="textRight">英文名：</Col>
	// 						<Col span={6}>{personalCenterDetail.english_name}</Col>
	// 						<Col span={2} className="textRight">入职日期：</Col>
	// 						<Col span={6}>{personalCenterDetail.entry_date}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">生日类型：</Col>
	// 						<Col span={6}>{personalCenterDetail.birthday_type_name}</Col>
	// 						<Col span={2} className="textRight">生日：</Col>
	// 						<Col span={6}>{personalCenterDetail.birthday}</Col>
	// 						<Col span={2} className="textRight">邮箱：</Col>
	// 						<Col span={6}>{personalCenterDetail.email}</Col>
	// 					</Row>
	// 				</div>
	// 			}
	// 			<div className="remindingImportant">合同信息</div>
	// 			{personalCenterDetail&&
	// 				<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 					<Row className="personalCenter">
	// 						<Col span={4} className="textRight">当前合同起始日：</Col>
	// 						<Col span={4}>{personalCenterDetail.contract_start_date}</Col>
	// 						<Col span={4} className="textRight">当前合同终止日：</Col>
	// 						<Col span={4}>{personalCenterDetail.contract_end_date}</Col>
	// 						<Col span={4} className="textRight">试用期到期日：</Col>
	// 						<Col span={4}>{personalCenterDetail.probation_end_date}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={4} className="textRight">试用期：</Col>
	// 						<Col span={4}>{personalCenterDetail.probation}</Col>
	// 						<Col span={2} className="textRight"></Col>
	// 						<Col span={6}></Col>
	// 						<Col span={2} className="textRight"></Col>
	// 						<Col span={6}></Col>
	// 					</Row>						
	// 				</div>
	// 			}
	// 			<div className="remindingImportant">员工信息</div>
	// 			{personalCenterDetail&&
	// 				<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">证件姓名：</Col>
	// 						<Col span={6}>{personalCenterDetail.real_name}</Col>
	// 						<Col span={2} className="textRight">民族：</Col>
	// 						<Col span={6}>{personalCenterDetail.nation_name}</Col>
	// 						<Col span={2} className="textRight">学历：</Col>
	// 						<Col span={6}>{personalCenterDetail.qualification_name}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">婚姻状况：</Col>
	// 						<Col span={6}>{personalCenterDetail.marital_status_name}</Col>
	// 						<Col span={2} className="textRight">微信：</Col>
	// 						<Col span={6}>{personalCenterDetail.wechat_id}</Col>
	// 						<Col span={2} className="textRight">QQ：</Col>
	// 						<Col span={6}>{personalCenterDetail.qq}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">居住地址：</Col>
	// 						<Col span={6}>{personalCenterDetail.live_address}</Col>
	// 						<Col span={4} className="textRight">紧急联系人姓名：</Col>
	// 						<Col span={4}>{personalCenterDetail.emergency_contact_name}</Col>
	// 						<Col span={4} className="textRight">紧急联系人电话：</Col>
	// 						<Col span={4}>{personalCenterDetail.emergency_contact_phone}</Col>
	// 					</Row>
	// 					<Row className="personalCenter">
	// 						<Col span={2} className="textRight">备注：</Col>
	// 						<Col span={22}>{personalCenterDetail.remarks}</Col>
	// 					</Row>						
	// 				</div>
	// 			}
	// 			<div className="remindingImportant">公司内兼任</div>
	// 			<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 				<Table columns={this.columnsCompany} 
	// 					dataSource={personalParttimes}
	// 					scroll={{x: 1010}}
	// 					rowKey={record => record.id} 
	// 					// onChange={this.fetchAttendanceRecord.bind(this)}
	// 					// rowKey={record => record.id} rowSelection={this.rowSelection}
	// 				 />					
	// 			</div>
	// 			<div className="remindingImportant">教育信息</div>
	// 			<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 				<Table columns={this.columnsEducations} 
	// 					dataSource={personalEducations}
	// 					scroll={{x: 1010}}
	// 					rowKey={record => record.id} 
	// 					// onChange={this.fetchAttendanceRecord.bind(this)}
	// 					// rowKey={record => record.id} rowSelection={this.rowSelection}
	// 				 />					
	// 			</div>
	// 			<div className="remindingImportant">工作经历</div>
	// 			<div style={{paddingTop:"20px", paddingBottom:"20px"}}>
	// 				<Table columns={this.columnsExperiences} 
	// 					dataSource={personalExperiences}
	// 					scroll={{x: 1010}}
	// 					rowKey={record => record.id} 
	// 					// onChange={this.fetchAttendanceRecord.bind(this)}
	// 					// rowKey={record => record.id} rowSelection={this.rowSelection}
	// 				 />					
	// 			</div>
	// 		</div>
	// 	)
	// }
}
// const mapStateToProps = state => {
// 	return {
// 		employee: state.employee
// 	}
// }

// const mapDispatchToProps = {
// 	fetchPersonalCenter
// }

// // PersonalCenter = Form.create()(PersonalCenter);

// export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(PersonalCenter));


// WEBPACK FOOTER //
// ./src/routes/Employee/PersonalCenterEn.js